import { ReactElement } from 'react';
import { StockCount } from '@client/common/components/StockCount';
import classNames from 'classnames';
import { Props } from './index';
import './Rows.scss';

export const Rows = ({
  className,
  onStockCountClick,
  rowsData,
}: Props): ReactElement => (
  <>
    {rowsData.map((row) => (
      <tr
        className={classNames(
          {
            'VariantsMatrixTable-Row2D': row.title,
          },
          className,
        )}
        key={row.title || 'rowKey'}
      >
        {row.title && <th>{row.title}</th>}

        {row.options.map(({ value, sku, stockInfo }) => (
          <td key={value}>
            {(!stockInfo || !sku)
              ? <span className='VariantsMatrixTable-EmptyCell'>x</span>
              : (
                <StockCount
                  isSpecialOrder={false}
                  onClick={onStockCountClick(sku)}
                  quantityOrdered={stockInfo.quantityOrdered}
                  stockCount={stockInfo.quantity}
                />
              )
            }
          </td>
        ))}
      </tr>
    ))}
  </>
);
